// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"553":"9d0b6814","591":"ddb7cda0"}[chunkId] + ".chunk.css";
};